// Lecture et écriture des fichiers CSV de l'invitation RDO.
// Le fichier déposé n'a besoin que d'une colonne : le NIR. Tout le reste
// (nom, prénom, date de naissance, email…) est retrouvé par l'API à partir du NIR.

// Délimiteur utilisé pour tous les fichiers CSV
export const CSV_DELIMITER = ";";

// Seule colonne requise dans le fichier déposé (comparée sans tenir compte de la casse)
export const COLONNE_NIR = "nir";

// Parser une ligne CSV en gérant les guillemets
const parseCSVLine = (line) => {
  const values = [];
  let current = "";
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    const nextChar = line[i + 1];

    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        // Guillemet échappé ""
        current += '"';
        i++; // Skip next quote
      } else {
        // Toggle quotes
        inQuotes = !inQuotes;
      }
    } else if (char === CSV_DELIMITER && !inQuotes) {
      // Fin de valeur
      values.push(current.trim());
      current = "";
    } else {
      current += char;
    }
  }

  // Ajouter la dernière valeur
  values.push(current.trim());

  return values;
};

// Lit un CSV en objets clés/valeurs. Un fichier vide ou réduit à l'en-tête
// renvoie une liste vide : c'est à l'appelant de dire quoi en faire.
export const parseCSV = (csvText) => {
  const lines = (csvText || "")
    .trim()
    .split(/\r\n|\r|\n/)
    .filter((line) => line.trim().length > 0);

  if (lines.length < 2) {
    return [];
  }

  const headers = lines[0].split(CSV_DELIMITER).map((h) => h.trim());
  const data = [];

  for (let i = 1; i < lines.length; i++) {
    const values = parseCSVLine(lines[i]);
    const row = {};
    headers.forEach((header, index) => {
      row[header] = values[index] || "";
    });
    data.push(row);
  }

  return data;
};

// Colonnes requises absentes d'une ligne lue, sans tenir compte de la casse des en-têtes
export const colonnesManquantes = (ligne) => {
  const presentes = Object.keys(ligne || {}).map((colonne) =>
    colonne.trim().toLowerCase()
  );
  return [COLONNE_NIR].filter((colonne) => !presentes.includes(colonne));
};

export const convertToCSV = (data, fields) => {
  if (!data || data.length === 0) return "";

  const headers = fields.map((f) => f.name).join(CSV_DELIMITER);
  const rows = data.map((row) =>
    fields
      .map((f) => {
        const value = row[f.path] || "";
        // Échapper les guillemets
        return `"${String(value).replace(/"/g, '""')}"`;
      })
      .join(CSV_DELIMITER)
  );

  return [headers, ...rows].join("\n");
};

export const downloadCSV = (csvContent, filename) => {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
